export const SIDEBAR_SHOW_SCREEN_SIZE = 1280;
